<template>
    <div>
        <app-header />
        <main>
            <div class="position-relative">
                <section class="section-shaped my-0 header-video">
                <vue-particles
                    color="#7367f0"
                    :particleOpacity="0.7"
                    :particlesNumber="60"
                    shapeType="polygon"
                    :particleSize="15"
                    linesColor="#dedede"
                    :linesWidth="1"
                    :lineLinked="true"
                    :lineOpacity="0.4"
                    :linesDistance="150"
                    :moveSpeed="3"
                    :hoverEffect="true"
                    hoverMode="grab"
                    :clickEffect="true"
                    clickMode="push"
                >
                </vue-particles>
                <!-- shape Hero -->
                    <div class="container header-container shape-container d-flex pb-5" style="padding-top: 12rem; margin-bottom:6.5rem;">
                        <div class="col px-0">
                            <div class="row">
                                <div class="col-lg-6 col-md-12">
                                    <h1 class="h1 customer-header text-white">Customer discovery. Idea validation.<br/> Finding your customers.</h1>
                                    <p class="lead text-white" style="font-size: 1.4rem;">With Hustleforge Premium we do it all! </p> 
                                    
                                    <div class="btn-wrapper text-center pt-5">
                                        <b-button 
                                            @click="gotoSignUp"
                                            class="btn btn-neutral btn-icon btn-lg"
                                            variant="gradient-primary">
                                            Start Today
                                        </b-button>
                                    </div>
                                </div> 
                                <!-- <div class="col-lg-auto col-md-12" style="width:500px; margin-top:-1rem">
                                    <b-embed
                                        type="iframe"
                                        aspect="4by3"
                                        src="https://player.vimeo.com/video/840698552"
                                        allowfullscreen
                                    ></b-embed>
                                </div>                               -->
                            </div>
                        </div>
                    </div>
                </section>
                <!-- 1st Hero Variation -->
            </div>
            <section class="section section-lg mt-3 mb-5">
                <div class="container">
                    <div class="row row-grid justify-content-center">
                        <div class="col-lg-9 text-center">
                            <h2 class="display-3"><img src="hflogocom.png" class="img-center img-fluid w-50">
                                <span class="text-primary mt-1">Is a platform to Connect</span>
                            </h2>
                            <p class="lead">For those who are seeking feeback, in need of advice, or looking for product fit. Hustleforge Premium does the hard work by finding, connecting, and talking to customers to help you discover if your idea has product market fit!</p>
                            <br/>
                            <h2 class="display-3"><span class="text-primary mt-1" style="font-size: smaller;">Why Hustleforge Premium?</span></h2>
                            <p class="lead">Validating a startup idea can be difficult, time consuming and confusing. Customer discovery is not simple and finding customers is a challange without the right network.</p>
                            <div class="btn-wrapper">
                                <b-button 
                                    @click="gotoSignUp"
                                    class="btn btn-neutral btn-icon btn-lg"
                                    variant="gradient-primary">
                                    Start Now
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section section section-shaped my-0 overflow-hidden pt-5">
                <div class="shape shape-style-1 bg-gradient-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container py-0">
                    <div class="row row-grid align-items-center">
                        <div class="col-md-5 order-lg-2 ml-lg-auto">
                            <div class="position-relative pl-md-5">
                                <div class="transform-perspective-right">
                                    <img src="@/assets/images/pages/login-v2-dark.svg" class="img-center chatscreen">
                                </div> 
                            </div>
                        </div>
                        <div class="col-lg-7 order-lg-1 mt-2">
                            <div class="d-flex">
                                <h3 class="display-3 text-white">Hustleforge Premium
                                    <span class="text-primary mt-1" style="font-style: italic;font-size: smaller;">Let us do the work for you</span>
                                </h3>
                            </div>
                            
                            <div class="d-flex">
                                <div>
                                    <p class="lead text-white">
                                        <!-- <icon name="ni ni-settings" size="sm" gradient="white" shadow round color="primary"></icon> -->
                                        <strong>1. Initial Call:</strong>  We meet with you to understand your business idea, target market, background and build your profile.
                                    </p>
                                    <p class="lead text-white mt-1"><strong>2. Customer Discovery:</strong> Our seasoned team identifies and conducts customer discovery on your behalf.</p>
                                    <p class="lead text-white"><strong>3. Customer Interviews:</strong> We confirm your customers and conduct customer interviews.</p>
                                    <p class="lead text-white"><strong>4. Customer Reports:</strong> We provide you with session recordings, notes, findings, and strong analysis to help guide your startup journey and launch better, smarter, faster.</p>
                                </div>
                            </div>
                            <div class="btn-wrapper text-center pt-5">
                                <b-button 
                                    @click="gotoSignUp"
                                    class="btn btn-neutral btn-icon btn-lg"
                                    variant="gradient-primary">
                                    Start Now
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section section-lg">
                <div class="container">
                    <div class="row row-grid justify-content-center">
                        <div class="col-lg-10 text-center">
                            <h2 class="display-3">FAQ</h2>
                            <p class="lead"> Find the answers for the most frequently asked questions below </p>
                        </div>
                    </div>

                    <div class="accordion" id="faqExample">
                        <div class="card">
                            <div class="card-header-landing p-2" id="headingOne">
                                <h3 class="mb-0">
                                   What is the best way to use Hustleforge?
                                    <!-- <i class="ni ni-bold-down float-right btn btn-link"></i> -->
                                </h3>
                            </div>

                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#faqExample">
                                <div class="card-body">
                                    <p>Hustleforge is typically used in a few key ways:</p>
                                    <ul>
                                        <li>Mentorship - finding or offering mentorship to students, peers, or new businesses/leadership teams in your field of expertise</li>
                                        <li>A side hustle - offering your knowledge and experience to those searching for your specific expertise</li>
                                        <li>Startup Validation - validate your startup idea or the problem you are trying to solve with those with specific knowledge of your target market</li>
                                        <li>Career change - find and engage other professionals in discussions about their career and find expertise/guidance to make a career change of your own (or advise others on their career changes)</li>
                                        <li>Other - personal development, life coaching, complex decision making, general advice, and more</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header-landing p-2" id="headingTwo">
                            <h3 class="mb-0">
                            How much does it cost? Can it be free?
                            </h3>
                        </div>
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#faqExample">
                            <div class="card-body">
                                <p>Our independent experts can set their rates for different purposes. For instance, there may be a rate for speaking with a student, a rate for business advising, a rate for micro-consulting, etc.</p>
                                <p>Experts/Customers can offer some or all of their services for free if they choose.</p>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header-landing p-2" id="headingThree">
                            <h3 class="mb-0">
                                What is an Expert?
                            </h3>
                        </div>
                        <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#faqExample">
                            <div class="card-body">
                                <p>Anyone with any significant knowledge of a problem, opportunity, or industry you might want to learn from. Typically, 5 years (10,000 hours) is a good gauge of experience to qualify someone as an ‘expert’.</p>
                                <p>This might be a nuclear engineer with 15 years of professional experience, but it also might be a gamer with 10 years of experience gaming, a coffee enthusiast who’s been drinking coffee for 20 years, or more. </p>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header-landing p-2" id="headingThree">
                            <h3 class="mb-0">
                                What if I am not an Expert?
                            </h3>
                        </div>
                        <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#faqExample">
                            <div class="card-body">
                                <p>That’s ok, there’s still a place for you at Hustleforge! People are searching for all sorts of expertise, even if you only have a few days, weeks or months of it. Have an interest in sports, poker or disc golf, but aren't a pro? That’s ok - list it as an interest on your profile and users can book your time to talk about your interests!</p>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header-landing p-2" id="headingThree">
                            <h3 class="mb-0">
                                How is this different from Upwork, Fiverr, or LinkedIn?
                            </h3>
                        </div>
                        <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#faqExample">
                            <div class="card-body">
                                <p>Upwork and Fiverr are geared toward full time gig work. While Hustleforge can also create opportunities for those seeking gig work, our primary goal is to make time and meaningful connections between professionals and those needing their expertise.</p>
                                <p>LinkedIn does help create connections like Hustleforge, but the busy people on LinkedIn are the same ones that it's hard to get in front of in person. Busy professionals are active everywhere, and getting the time and good feedback from LinkedIn connections can take time.</p>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header-landing p-2" id="headingFour">
                            <h3 class="mb-0">
                                Why was Hustleforge built?
                            </h3>
                        </div>
                        <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#faqExample">
                            <div class="card-body">
                                <p>Hustleforge is the answer to a problem the two founders have experienced personally.</p>
                                <p>When attempting to build a startup and find an MVP, they found connecting with professionals in their target market very difficult. Everyone was busy, had too many distractions, and it took more work to get face time with decision-makers. No one had time, and very few people wanted to talk to an unknown person.</p>
                                <p>Even worse, existing processes for validating startup ideas need to be revised for part-time side hustlers. It's hard to reach your target market when you're at your day job!</p>
                                <p>This is why we built Hustleforge: to introduce side hustlers, students, and people needing expertise with willing and available experts. These experts can share their extensive knowledge, develop their brand, and create a revenue stream while making their extensive knowledge accessible to everyone!</p>
                            </div>
                        </div>
                    </div>
                    <div class="row row-grid justify-content-center mt-5">
                        <div class="btn-wrapper text-center">
                            <b-button 
                                @click="gotoSignUp"
                                class="btn btn-neutral btn-icon btn-lg"
                                variant="gradient-primary">
                                Start Now
                            </b-button>
                        </div>
                    </div>
                </div>
            </section>
            <!-- Modal -->
            <div class="modal fade" id="waitlistModalSucess" tabindex="-1" role="dialog" aria-labelledby="waitlistModalSucess" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="waitlistModalSucessTitle">Welcome to the Waitlist</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <!-- <span aria-hidden="true">&times;</span> -->
                            </button>
                        </div>
                        <div class="modal-body">
                            Welcome to our waitlist. We are excited you've shown interest in our community. We will notify you by email once we have availability. Thanks again, the Hustleforge Team!
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <app-footer />
    </div>
</template>

<script>
import { getFirestore, collection, addDoc } from "firebase/firestore";
const db = getFirestore()

import {
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea, 
  BCard,
  BCardText,
  BAvatar,
  BImg,
  BMedia, 
  BMediaAside,
  BMediaBody,
  BCardHeader,
  BBadge,
  BCardBody,
  BLink,
  BEmbed
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import AppFooter from './AppFooter.vue'
import AppHeader from './AppHeader.vue'

export default {
    components: {
        BRow,
        BCol,
        BButton,
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
        BFormTextarea, 
        BCard,
        BCardText,
        BAvatar,
        ValidationProvider,
        ValidationObserver,
        AppFooter,
        AppHeader,
        BImg,
        BMedia, 
        BMediaAside,
        BMediaBody,
        BCardHeader,
        BBadge,
        BCardBody,
        BLink,
        BEmbed
    },
    name: "home",
    title: 'Hustleforge',
    data: function(){
        return {
            errors: [],
            name: null,
            email: null,
            expert: null,
            description: null,
                  
            // validation rules
            required,
            email,
        }
    },
    methods: {
        gotoSignUp(){
            this.$router.push({ name: 'auth-register'})  
        },
        scrollToWaitlist() {
            const element = document.getElementById('waitlist')
            element.scrollIntoView({ behavior: 'smooth' })
        },
        async addwaitlist(){
            try {
                const docRef = await addDoc(collection(db, "waitlist"), {
                    name: this.name,
                    email: this.email,
                    type: this.expert,
                    description: this.description,
                    time: new Date(),
                });
                //console.log("Document written with ID: ", docRef.id);
                document.getElementById("waitlistModalSucess").style.display = "block"
                document.getElementById("waitlistModalSucess").classList.add("show")
            } catch (e) {
               console.error("Error adding document: ", e);
            }

            this.name= ''
            this.email = ''
            this.expert = ''
            this.description = ''
        },
        checkForm: function (e) {
            e.preventDefault();

            // Get the modal
            var modal = document.getElementById('waitlistModalSucess');

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function(event) {
                if (event.target == modal) {
                    document.getElementById("waitlistModalSucess").style.display = "none"
                    document.getElementById("waitlistModalSucess").classList.remove("show")
                }
            }

            if (this.name && this.email && this.description) {
                this.addwaitlist();
            }

            this.errors = [];

            if (!this.name) this.errors.push('Name required.');
            if (!this.email) this.errors.push('Email required.');
            if (!this.description) this.errors.push('Tell us what your looking for');
        },
    }
};
</script>
